export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14419.49c89d04.jpg";